import React, { createContext, useContext, useState } from "react";
import { UserModel } from "../services/Login/LoginService";
interface AppContextType {
  accessToken: string;
  setAccessToken: (token: string) => void;

  userData: UserModel | null;
  setUserData: (site: UserModel) => void;

  //dropBox
  dropBoxRefreshToken: string;
  setDropBoxRefreshToken: (value: string) => void;

  dropBoxAccessToken: string;
  setDropBoxAccessToken: (value: string) => void;

  dropBoxAppSecret: string;
  setDropBoxAppSecret: (value: string) => void;

  dropBoxAppKey: string;
  setDropBoxAppKey: (value: string) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [accessToken, setAccessToken] = useState<string>("");
  const [userData, setUserData] = useState<UserModel | null>(null);
  const [dropBoxRefreshToken, setDropBoxRefreshToken] = useState<string>("");
  const [dropBoxAccessToken, setDropBoxAccessToken] = useState<string>("");
  const [dropBoxAppSecret, setDropBoxAppSecret] = useState<string>("");
  const [dropBoxAppKey, setDropBoxAppKey] = useState<string>("");
  return (
    <AppContext.Provider
      value={{
        accessToken,
        setAccessToken,
        userData,
        setUserData,
        dropBoxRefreshToken,
        setDropBoxRefreshToken,
        dropBoxAccessToken,
        setDropBoxAccessToken,
        dropBoxAppSecret,
        setDropBoxAppSecret,
        dropBoxAppKey,
        setDropBoxAppKey,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};
